import { createHashRouter, createRoutesFromElements, Route } from 'react-router-dom';
import { ErrorBoundary } from 'src/components/ErrorBoundary';
import AppLayout from 'src/layout/AppLayout';
import { suspendPageLoad } from 'src/routes/suspendPageLoad';
import { detectFeatureToggles } from 'src/configuration/setup/featureToggles';

// Lazy load pages for better performance and automatically split the bundle accordingly
const Intro = suspendPageLoad(() => import('src/pages/Intro'));
const ConfLogicContainer = suspendPageLoad(() => import('src/pages/ConfLogicContainer'));
const TemplatesContainer = suspendPageLoad(() => import('src/pages/TemplatesContainer'));
const TranslationsContainer = suspendPageLoad(() => import('src/pages/TranslationsContainer'));
// const UserSidebarLoader = suspendPageLoad(() => import('../features/users/userSidebar/UserSidebarLoader'));

export const DEFAULT_ROUTE = '/intro';
export const ROUTE_TEMPLATES = '/templates';
export const ROUTE_CONFLOGIC = '/conflogic';
export const ROUTE_TRANSLATIONS = '/translations';

export const routes = [DEFAULT_ROUTE, ROUTE_CONFLOGIC, ROUTE_TEMPLATES, ROUTE_TRANSLATIONS];
const {
    // useConfLogic,
    useTemplates,
    // useTranslations
} = detectFeatureToggles();
const DefaultRoute = <Route path={DEFAULT_ROUTE} errorElement={<ErrorBoundary />} element={<Intro />} />;
const ConfLogicRoute = (
    <Route path={ROUTE_CONFLOGIC} errorElement={<ErrorBoundary />} element={<ConfLogicContainer />} />
);
const TemplateRoute = (
    <Route path={ROUTE_TEMPLATES} errorElement={<ErrorBoundary />} element={<TemplatesContainer />} />
);
const TranslationsRoute = (
    <Route path={ROUTE_TRANSLATIONS} errorElement={<ErrorBoundary />} element={<TranslationsContainer />} />
);
export const router = createHashRouter(
    createRoutesFromElements(
        <Route path='/' element={<AppLayout />}>
            {DefaultRoute}
            {/*{useConfLogic && ConfLogicRoute}*/}
            {ConfLogicRoute}
            {useTemplates && TemplateRoute}
            {/*{useTranslations && TranslationsRoute}*/}
            {TranslationsRoute}
        </Route>
    )
);
